import type { RouteRecordRaw } from 'vue-router'
// import BlogDetailPage from '../../pages/BlogDetailPage.vue'
// import BlogPage from '../../pages/BlogPage.vue'
import api from '../../services/api' // axios instance
import { BlogPostPage } from '@myorg/blog-lib'
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'


// 實作 Lib 定義的介面
export const blogApi = {
  // fetchPosts: async (page: number, size: number) => {
  //   // 這裡會對應您提供的 API JSON 結構
  //   const res = await api().get(`${API_ENDPOINTS.BLOG.POSTS}?page=${page}&pageSize=${size}`)
  //   return res.data
  // },

  // createPost: async (title: string, content: string) => {
  //   const res = await api().post(API_ENDPOINTS.BLOG.POSTS, { title, content })
  //   return res.data
  // },

  // addComment: async (postId: string, content: string) => {
  //   await api().post(`${API_ENDPOINTS.BLOG.COMMENTS}/${postId}/comments`, { content })
  // },

  // deletePost: async (postId: string) => {
  //   await api().delete(`${API_ENDPOINTS.BLOG.POSTS}/${postId}`)
  // }
}

// const blogApi = {
//   fetchPosts: async (page: number, pageSize: number) => {
//     const res = await api().get(`/posts?page=${page}&pageSize=${pageSize}`)
//     return res.data
//   },
//   submitPost: async (data: any) => {
//     await api().post('/posts', data)
//   },
//   fetchPostDetail: async (id: string) => {
//     const res = await api().get(`/posts/${id}`)
//     return res.data
//   },
//   submitComment: async (postId: string, content: string) => {
//     await api().post(`/posts/${postId}/comments`, { content })
//   }
// }

// export const blogDetailRoute: RouteRecordRaw = {
//   path: '/blog/:id',
//   name: 'BlogDetail',
//   component: BlogDetailPage,
//   props: true
// }

export const blogRoute: RouteRecordRaw = {
  path: ROUTES.BLOG.PATH,
  name: ROUTES.BLOG.NAME,
  component: BlogPostPage,
  // props: { blogApi },
  props: (route) => ({
    blogPostApi: blogApi,
  })
}
